import { type ReactNode } from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { MdCheck } from 'react-icons/md';
import { RiftboundButton, type RiftboundButtonProps } from './button';

export interface RiftboundMenuItemButtonProps extends Omit<RiftboundButtonProps, 'children'> {
  children: ReactNode;
  selected?: boolean;
  showCheck?: boolean;
}

export function RiftboundMenuItemButton({
  children,
  selected = false,
  showCheck = true,
  disabled,
  _hover,
  _active,
  ...rest
}: RiftboundMenuItemButtonProps) {
  const hoverOverride = disabled
    ? { bg: 'transparent', borderColor: 'transparent' }
    : _hover;
  const activeOverride = disabled ? { bg: 'transparent' } : _active;

  return (
    <RiftboundButton
      treatment="ghost"
      variant={selected ? 'selected' : 'menuItem'}
      size="sm"
      w="100%"
      justifyContent="stretch"
      h="auto"
      minH="44px"
      px={3}
      py={2}
      borderRadius="md"
      disabled={disabled}
      {...(hoverOverride ? { _hover: hoverOverride } : {})}
      {...(activeOverride ? { _active: activeOverride } : {})}
      {...rest}
    >
      <HStack gap={3} w="100%" minW={0} justify="space-between">
        <Box flex={1} minW={0} textAlign="left">
          {typeof children === 'string' ? (
            <Text
              as="span"
              display="block"
              truncate
              fontWeight={selected ? 'semibold' : 'medium'}
            >
              {children}
            </Text>
          ) : (
            children
          )}
        </Box>
        {showCheck ? (
          <Box
            aria-hidden
            color={selected ? 'accent' : 'transparent'}
            flexShrink={0}
            opacity={selected ? 1 : 0}
          >
            <MdCheck size={17} />
          </Box>
        ) : null}
      </HStack>
    </RiftboundButton>
  );
}
